import { constructEnum } from '@/lib/enum';

export default constructEnum('PurchasePurpose', {
  NONE: 0,
  GIFT: 10,
  EXPERIENCE: 20
});
